module.exports = __webpack_public_path__ + "media/military/Military_hm-4d533f1e.png";